import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { GithubIcon, ProtocolLabsSymbolIcon, MoxyLogoIcon } from '../icon';
import { LayoutContainer } from '../layout';
import styles from './Footer.module.css';

const Footer = ({ className }) => (
    <LayoutContainer
        component="footer"
        className={ classNames(styles.footer, className) }>
        <div className={ classNames(styles.footerContent) }>
            <div className={ styles.githubLink }>
                Nomios © 2019 – Build with us, join our GitHub.
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://github.com/ipfs-shipyard/pm-idm#contributing"
                    aria-label="Build with us on GitHub">
                    <GithubIcon className={ styles.githubLogo } />
                </a>
            </div>

            <div className={ styles.githubLinkTablet }>
                Nomios © 2019 – Build with us.
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://github.com/ipfs-shipyard/pm-idm#contributing"
                    aria-label="Build with us on GitHub">
                    <GithubIcon className={ styles.githubLogo } />
                </a>
            </div>

            <div className={ styles.companies } >
                <div className={ styles.moxy }>
                    Built by
                    <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://moxy.studio"
                        aria-label="MOXY">
                        <MoxyLogoIcon className={ styles.moxyBrand } />
                    </a>
                </div>
                <div className={ styles.protocolLabs }>
                    Sponsored by
                    <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://protocol.ai/"
                        aria-label="Protocol Labs">
                        <ProtocolLabsSymbolIcon className={ styles.plBrand } />
                    </a>
                </div>

            </div>

            <div className={ styles.companiesTablet }>
                Build with us.
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://github.com/ipfs-shipyard/pm-idm#contributing"
                    aria-label="Build with us on GitHub">
                    <GithubIcon className={ styles.githubLogo } />
                </a>
            </div>

            <div className={ styles.copyrightMobile }>
                Nomios © 2019 –&nbsp;
                <a
                    className={ styles.githubLinkMobile }
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://github.com/ipfs-shipyard/pm-idm#contributing">
                    Build with us on GitHub.
                </a>
            </div>
        </div>
    </LayoutContainer>
);

Footer.propTypes = {
    className: PropTypes.string,
};

export default Footer;
